
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pozicovne-lyziarskej-vystroje",
      function () {
        return require("private-next-pages/[region]/[resort]/pozicovne-lyziarskej-vystroje.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pozicovne-lyziarskej-vystroje"])
      });
    }
  